import { render, staticRenderFns } from "./BrowserCompatibilityWarning.vue?vue&type=template&id=98363afc&scoped=true&"
import script from "./BrowserCompatibilityWarning.vue?vue&type=script&lang=js&"
export * from "./BrowserCompatibilityWarning.vue?vue&type=script&lang=js&"
import style0 from "./BrowserCompatibilityWarning.vue?vue&type=style&index=0&id=98363afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98363afc",
  null
  
)

export default component.exports